export const filteringTableGetButtonIcon = (nominationStatusTypeId) =>
  nominationStatusTypeId === 1
    ? 'bi bi-pen action-button'
    : 'bi bi-eye view-button';
